import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { AiChatWidgetHost, AiChatWidgetHostProps } from '@systemeio/ai-chat-widget';
import { useRevalidateModules } from '@systemeio/util';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { pageRoute } from 'shared/constants/routes.constants';
import useUser from 'shared/hooks/use-user';
import { getPageRoute } from 'shared/utils/get-dynamic-page-route';
import { mcpToolRevalidationModules } from 'help-bots/ai-chat/constants/mcp-tool-revalidation-modules';
export const AiChatTriggerButton = () => {
  const $ = _c(4);
  const {
    user
  } = useUser();
  const aiChatFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.AiChat);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] !== revalidateModules) {
    t0 = toolCall => {
      if (toolCall.output.isError) {
        return;
      }
      const modules = mcpToolRevalidationModules[toolCall.toolName];
      if (modules) {
        revalidateModules(modules, true);
      }
    };
    $[0] = revalidateModules;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleToolCallOutput = t0;
  if (!aiChatFeatureIsOn || !user) {
    return null;
  }
  let t1;
  if ($[2] !== handleToolCallOutput) {
    t1 = <div data-test-id="ai-chat-button"><AiChatWidgetHost UpgradeLink={_temp} onToolCallOutput={handleToolCallOutput} /></div>;
    $[2] = handleToolCallOutput;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(props) {
  return <LinkWithoutPrefetch href={getPageRoute(pageRoute.ProfileUserPlan)} {...props} />;
}